import PropTypes from 'prop-types';
import * as ALOOMA from 'consts/alooma';
import Modal from 'components/templates/Modal/Modal';
import ModalBodyGiftCardsCategories from 'components/molecules/ModalBodyGiftCardsCategories/ModalBodyGiftCardsCategories';

const ModalGiftCardsCategories = props => {
  const { closeModal, sourcePage } = props;

  return (
    <Modal
      source={sourcePage}
      aloomaModalType={ALOOMA.MODAL_TYPES.POPUP}
      aloomaModalName={ALOOMA.MODAL_NAMES.GIFT_CARD_CATEGORIES}
      onClose={closeModal}
      sendPageView={false}
    >
      <ModalBodyGiftCardsCategories {...props} />
    </Modal>
  );
};

ModalGiftCardsCategories.propTypes = {
  closeModal: PropTypes.func.isRequired,
  sourcePage: PropTypes.string.isRequired,
};

export default ModalGiftCardsCategories;
